import React                     from "react";
import PropTypes                 from 'prop-types';
import Translations              from "../../utils/Translations";
import {VXPay}                   from "../../utils/VXPay";
import Flux                      from "../../flux/Flux";
import GuestAvatar               from "../GuestAvatar";
import ReloadHelper              from '../../utils/ReloadHelper';
import UrlBuilder                from "../../utils/UrlBuilder";
import {trackUserMenuClick}      from "../../utils/GAHelper";
import VipLogout                 from "../ExitIntent/VipLogout";
import {shouldShowVipExitIntent} from '../../utils/CommonUtils';

//import {openModalBox, ModalBoxEnum} from "../ModalBox/ModalBoxFactory";

class NavbarGuestMenuDropdown extends React.Component {

	static pjaxLinkHandler(e) {
		const wrapper = document.getElementById('navbar-menu-guestmenu');
		if (wrapper && wrapper.classList.contains('is-expanded')) {
			wrapper.classList.remove('is-expanded');
		}
		if (e.currentTarget && e.currentTarget.href) {
			ReloadHelper.reloadWithPjax(e.currentTarget.href, e);
		}
	}

	constructor(props) {
		super(props);
		this.state            = {
			guestBalanceFormatted: this.props.initialGuestBalanceFormatted,
			showVipExitIntent:     false,
		};
		this.onStoreChange    = this.onStoreChange.bind(this);
		this.onBalanceClick   = this.onBalanceClick.bind(this);
		this.onPromocodeClick = this.onPromocodeClick.bind(this);
		this.onSettingsClick  = this.onSettingsClick.bind(this);
		this.onLogoutClick    = this.onLogoutClick.bind(this);
	}

	componentDidMount() {
		Flux.Guest.addChangeListener(this.onStoreChange);
	}

	componentWillUnmount() {
		Flux.Guest.removeChangeListener(this.onStoreChange);
	}

	onStoreChange() {
		this.setState({
			guestBalanceFormatted: Flux.Guest.getBalanceFormatted(),
		});
	}

	onBalanceClick(event) {
		event.preventDefault();
		VXPay.openPaytour();
	}

	onBenefitsClick(event) {
		event.preventDefault();
		ReloadHelper.reloadWithPjax(UrlBuilder.buildMyVisitXBenefitsRoute(), event);
	}

	// voucher
	onPromocodeClick(event) {
		event.preventDefault();
		VXPay.openPromoCode();
	}

	// log out
	onLogoutClick(event) {
		event?.preventDefault();
		event?.stopPropagation();
		if (shouldShowVipExitIntent() && !this.state.showVipExitIntent) {
			this.setState({showVipExitIntent: true});
		} else {
			VXPay.logout();
		}
	}

	// settings
	onSettingsClick(event) {
		event.preventDefault();
		VXPay.openSettings();
		if (this.props.myVisitXGuestFavoriteActorsUrl && window.location.href.includes(this.props.myVisitXGuestFavoriteActorsUrl)) {
			// wait for Vxpay Settings close event
			VXPay.onSettingsClose(() => {
				window.location.reload();
			});
		}
	}

	render() {
		const menuItems      = [];
		const isVip          = Flux.Guest.isVip();
		const isPremium      = Flux.Guest.isPremium();
		const guestNameClass = (this.props.guestName.length < 15) ? "dropdown-menu__guest-name" : "dropdown-menu__guest-name -small";
		// profile
		menuItems.push(
			<li className="dropdown-menu__item__table" key="guest">
				<a href={this.props.myVisitXGuestProfileUrl}
				   onClick={(e) => {
					   NavbarGuestMenuDropdown.pjaxLinkHandler(e);
					   trackUserMenuClick('profile', this.props.myVisitXGuestProfileUrl);
				   }}
				   className={"h-color-bg -hover h-disp-block" + (isVip ? ' dropdown-menu-special-bg' : '')}
				>
					<span className={"dropdown-menu__item" + (isVip ? ' -no-bg' : '')}>
						<span className="dropdown-menu__item__cell h-text-align-center">
							<GuestAvatar guestName={this.props.guestName}
							             guestUrlPreviewPicture={this.props.guestUrlPreviewPicture}
							             labelUrl={null}
							             isPremium={isPremium}
							             isVip={isVip}
							             size={isVip || isPremium ? 65 : 80}
							             onImageClick={NavbarGuestMenuDropdown.pjaxLinkHandler}
							/>
							<br />
							<span className={guestNameClass}>
								{this.props.guestName}
							</span>
							<br />
							<span className="dropdown-menu__guest-profile-link">
								{Translations.get('NavbarGuestMenuProfileLink')}
							</span>
						</span>
					</span>
				</a>
			</li>
		);

		if (!isVip) {
			menuItems.push(
				<li className="dropdown-menu__item__table h-bg-color-gold" key="vip">
					<a href={this.props.vipClubUrl} onClick={(e) => {
						NavbarGuestMenuDropdown.pjaxLinkHandler(e);
						trackUserMenuClick('getvip', this.props.vipClubUrl);
					}}
					   className="dropdown-menu__item">
						<span className="dropdown-menu__item__cell">
							<i className="icon -icon-person-vip" />
						</span>
						<span className="dropdown-menu__item__cell">
							{Translations.get('GetVip')}
						</span>
					</a>
				</li>
			);
		}

		// My VISIT-X
		menuItems.push(
			<li className="dropdown-menu__item__table" key="myvisitx">
				<a href={this.props.myVisitXUrl} onClick={(e) => {
					NavbarGuestMenuDropdown.pjaxLinkHandler(e);
					trackUserMenuClick('myvisitx', this.props.myVisitXUrl);
				}} className="dropdown-menu__item">
					<span className="dropdown-menu__item__cell">
						<i className="icon -icon-user-full" />
					</span>
					<span className="dropdown-menu__item__cell">
						{Flux.Browser.isSexole() ? 'Mi Sexole' : Translations.get('MainNavMyVisitX')}
					</span>
				</a>
			</li>
		);

		if (this.props.privateCollection) {
			menuItems.push(
				<li className="dropdown-menu__item__table" key="myPrivateCollection">
					<a href={this.props.privateCollection} onClick={(e) => {
						NavbarGuestMenuDropdown.pjaxLinkHandler(e);
						trackUserMenuClick('private-collection', this.props.privateCollection);
					}} className="dropdown-menu__item">
					                                               <span className="dropdown-menu__item__cell">
                                                       <i className="icon -icon-chat-flat" />
                                               </span>
						<span className="dropdown-menu__item__cell">
                                                       {Translations.get('NavbarGuestMenuPrivateCollection')}
					                                               </span>
					</a>
				</li>
			);
		}

		// balance
		menuItems.push(
			<li className="dropdown-menu__item__table" key="balance">
				<a href="#" onClick={(e) => {
					this.onBalanceClick(e);
					trackUserMenuClick('balance', '#');
				}}
				   className="dropdown-menu__item">
					<span className="dropdown-menu__item__cell">
						<i className={`icon -icon-vxcoin`} />
					</span>
					<span className="dropdown-menu__item__cell">
						{Translations.get('NavbarGuestMenuBalance')}: {this.state.guestBalanceFormatted}
					</span>
				</a>
			</li>
		);

		// Benefits
		menuItems.push(
			<li className="dropdown-menu__item__table" key="benefits">
				<a href="#" onClick={(e) => {
					this.onBenefitsClick(e);
					trackUserMenuClick('benefits', UrlBuilder.buildMyVisitXBenefitsRoute());
				}} className="dropdown-menu__item">
					<span className="dropdown-menu__item__cell">
						<i className="icon -icon-benefits-full" />
					</span>
					<span className="dropdown-menu__item__cell">
						{Translations.get('myvisitx_benefits.menu-entry')}
					</span>
				</a>
			</li>
		);

		menuItems.push(
			<li className="dropdown-menu__item__table" key="settings">
				<a href="#" onClick={(e) => {
					this.onSettingsClick(e);
					trackUserMenuClick('settings', '#');
				}} className="dropdown-menu__item">
					<span className="dropdown-menu__item__cell">
						<i className="icon -icon-settings-full" />
					</span>
					<span className="dropdown-menu__item__cell">
						{Translations.get('NavbarGuestMenuSettings')}
					</span>
				</a>
			</li>
		);


		menuItems.push(
			<li className="dropdown-menu__item__table" key="logout">
				<a href="#" onClick={(e) => {
					this.onLogoutClick(e);
					trackUserMenuClick('logout', '#');
				}} className={"dropdown-menu__item" + (this.state.showVipExitIntent ? ' dropdown-menu__item--active' : '')}>
					<span className="dropdown-menu__item__cell">
						<i className="icon -icon-power-line" />
					</span>
					<span className="dropdown-menu__item__cell">
						{Translations.get('NavbarGuestMenuLogOut')}
					</span>
				</a>
			</li>
		);

		return (
			<ul className={"dropdown-menu -padding-high__item h-list--unstyled-block" + (this.state.showVipExitIntent ? ' dropdown-menu--visible' : '')}>
				{menuItems}
				{this.state.showVipExitIntent &&
					<VipLogout isAbsolute={true} onLogoutClick={this.onLogoutClick} incentive={Flux.Conversion.getExitIntentLogoutIncentive()} />}
			</ul>
		);
	}
}

NavbarGuestMenuDropdown.propTypes = {
	initialGuestBalanceFormatted:   PropTypes.string.isRequired,
	guestName:                      PropTypes.string,
	guestUrlPreviewPicture:         PropTypes.string,
	vipClubUrl:                     PropTypes.string,
	myVisitXGuestProfileUrl:        PropTypes.string,
	myVisitXGuestFavoriteActorsUrl: PropTypes.string,
	myVisitXUrl:                    PropTypes.string,
	privateCollection:              PropTypes.string,
};

export default NavbarGuestMenuDropdown;
